import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CommercialActions, CommercialSelectors, PartnerAccessInvitationFormData } from '@store';
import { Observable } from 'rxjs';
import { InvitationStatusType } from '../../../projects/client';

@Injectable({
  providedIn: 'root',
})
export class CommercialStore {
  fetchedInvitations$ = this.store.select(CommercialSelectors.fetchedInvitations);
  invitationsToSend$ = this.store.select(CommercialSelectors.invitationsToSend);
  isFetchingInvitations$ = this.store.select(CommercialSelectors.isFetchingInvitations);
  isNoInstallationToSend$ = this.store.select(CommercialSelectors.isNoInstallationToSend);
  isCustomerInvitationPresent$ = this.store.select(CommercialSelectors.isCustomerInvitationPresent);

  constructor(private store: Store) {}

  fetchPartnerAccessList(): void {
    this.store.dispatch(CommercialActions.fetchPartnerAccessList.attempt());
  }

  cancelFetchingPartnerAccessList(): void {
    this.store.dispatch(CommercialActions.fetchPartnerAccessList.cancel());
  }

  removeInvitation(token: string, status: InvitationStatusType): void {
    this.store.dispatch(CommercialActions.removePartnerAccessInvitation.attempt({ token, status }));
  }
  updateInvitationVisibility(token: string, isVisible: boolean): void {
    this.store.dispatch(
      CommercialActions.updateVisibilityOfPartnerAccessInvitation.attempt({ token, isVisible })
    );
  }

  addPartnerToForm(invitation: PartnerAccessInvitationFormData): void {
    this.store.dispatch(CommercialActions.modifyPartnerAccessInvitations.add({ invitation }));
  }

  removePartnerFromForm(index: number): void {
    this.store.dispatch(CommercialActions.modifyPartnerAccessInvitations.remove({ index }));
  }

  clearPartnerFromForm(): void {
    this.store.dispatch(CommercialActions.modifyPartnerAccessInvitations.clear());
  }

  sendInvitationsForm(): void {
    this.store.dispatch(CommercialActions.sendPartnerAccessInvitations.sendAll());
  }

  sendSpecificInvitation(index: number): void {
    this.store.dispatch(CommercialActions.sendPartnerAccessInvitations.sendOne({ index }));
  }

  getInvitationWithIndex(index: number): Observable<PartnerAccessInvitationFormData> {
    return this.store.select(CommercialSelectors.getInvitationWithIndex(index));
  }

  isEmailAlreadyInvited(email: string): Observable<boolean> {
    return this.store.select(CommercialSelectors.isEmailAlreadyInvited(email));
  }

  isEmailAlreadyInForm(email: string): Observable<boolean> {
    return this.store.select(CommercialSelectors.isEmailAlreadyInForm(email));
  }
}
